import { createFileRoute, notFound } from "@tanstack/react-router";

import { DevelopersView } from "@/components/pages/DevelopersView";
import { meta } from "@/content/meta";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";

export const Route = createFileRoute("/$locale/developers")({
  head: ({ params }) =>
    isLocale(params.locale)
      ? seoHead({
          locale: params.locale,
          path: "/developers",
          ...meta[params.locale].developers,
        })
      : {},
  component: DevelopersRoute,
});

function DevelopersRoute() {
  const { locale } = Route.useParams();
  if (!isLocale(locale)) throw notFound();
  return <DevelopersView locale={locale} />;
}
